import { render, staticRenderFns } from "./InventorySupplierViewInformation.vue?vue&type=template&id=9821a15c&"
import script from "./InventorySupplierViewInformation.vue?vue&type=script&lang=js&"
export * from "./InventorySupplierViewInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports